import classNames from 'classnames';
import React, { useState, useEffect } from 'react';

import { Icon, IconTypes } from '@eika/icon';

import { useConfig } from '../../../../defaultConfig';
import { useOutboxQuery } from '../../../../fetchHooks/useOutbox';
import useTranslation from '../../../../hooks/useTranslation';

import './BulkPaymentLink.scss';

const BulkPaymentLink: React.FC = () => {
    const translated = useTranslation();
    const [blink, setBlink] = useState<boolean>(false);

    const { featureToggles, paymentsForApprovalLink } = useConfig();
    const { data = [] } = useOutboxQuery(featureToggles.enableBulkPayment);
    const [count, setCount] = useState(data?.length);

    useEffect(() => {
        setBlink(true);
        setCount(data?.length);

        const timer = setTimeout(() => {
            setBlink(false);
        }, 200);

        return () => {
            clearTimeout(timer);
        };
    }, [data?.length]);

    const formattedCount = count > 100 ? '99+' : `${count}`;
    return (
        <a
            type="button"
            className="bulk-payment-link__body"
            href={paymentsForApprovalLink?.url}
            data-testid="to-outbox-link"
        >
            <div
                className={classNames('bulk-payment-link__length', {
                    'bulk-payment-link__blink': blink,
                    'round-corners': formattedCount.length === 1,
                })}
                data-testid="number-of-outbox-payments"
            >
                <span>{formattedCount}</span>
            </div>
            <p className="bulk-payment-link__text">{translated.paymentsForApproval}</p>
            <Icon className="icon--24" type={IconTypes.PIL_HOEYRE} />
        </a>
    );
};

export default BulkPaymentLink;
